import React from "react";
import styled from "styled-components";
import { FaHome, FaHistory, FaCoins, FaCog, FaInfoCircle, FaGavel } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectTilesDetails, selectRestrictedDataError } from "../../../mainApp/features/DataSlice/dataSlice";
import { auth, db  } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useState, useEffect } from "react";

// Styled components dla LeftNavigationBar
const NavContainer = styled.div`
  position: fixed;
  top: 94px;
  left: 0;
  height: calc(100vh - 104px);
  width: 70px;
  // background-color: ${({ theme }) => theme.color.spotifyBlack};
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  transition: width 0.3s ease, opacity 0.3s ease;
  z-index: 100;
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")};
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};

  &:hover {
    width: 200px;
  }

  /* Dla szerokości 1460px i mniejszych – nie rozwijaj paska */
  @media (max-width: 1460px) {
    &:hover {
      width: 70px;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled(NavLink)`
  width: 100%;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.color.spotifyWhite};
  cursor: pointer;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  will-change: background-color;

  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
    border-radius: 4px;
  }
`;

const NavIcon = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  width: 24px;
  margin-left: 23px;
  display: flex;
  justify-content: center;
`;

const NavLabel = styled.span`
  margin-left: 15px;
  font-size: 16px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  display: none;
  white-space: nowrap;

  ${NavContainer}:hover & {
    display: inline;
  }

  /* Dla szerokości 1460px i mniejszych – nie pokazuj etykiet przy hover */
  @media (max-width: 1460px) {
    ${NavContainer}:hover & {
      display: none;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const LeftNavigationBar = ({ isLoading }) => {
  const location = useLocation();
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const [user, setUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      setUser(currentUser);
      if (currentUser && currentUser.emailVerified) {
        const docRef = doc(db, "Users", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserDetails(docSnap.data());
        }
      } else {
        setUserDetails(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Lista ścieżek, na których ukrywamy LeftNavigationBar
  const hiddenPaths = [
    "/404",
    "/unauthorized",
    "/profile",
    "/register",
    "/login",
    "/reset-password",
    "/email-verification",
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/pricing"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/home"] : []),
     ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/policy"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/regulations"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/profilePage"] : []),
     ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/info"] : []),
  ];

  const isVisible = !hiddenPaths.includes(location.pathname);

  return (
    <NavContainer isLoading={isLoading} isVisible={isVisible}>
      <NavItem to="/home">
        <NavIcon>
          <FaHome />
        </NavIcon>
        <NavLabel>Home</NavLabel>
      </NavItem>
      <NavItem to="/chatbot-history">
        <NavIcon>
          <FaHistory />
        </NavIcon>
        <NavLabel>Historia</NavLabel>
      </NavItem>
      <NavItem to="/tokens">
        <NavIcon>
          <FaCoins />
        </NavIcon>
        <NavLabel>Tokeny</NavLabel>
      </NavItem>
      <NavItem to="/settings">
        <NavIcon>
          <FaCog />
        </NavIcon>
        <NavLabel>Ustawienia</NavLabel>
      </NavItem>
      <NavItem to="/help">
        <NavIcon>
          <FaInfoCircle />
        </NavIcon>
        <NavLabel>Pomoc</NavLabel>
      </NavItem>
      <NavItem to="/settings/policy">
        <NavIcon>
          <FaGavel />
        </NavIcon>
        <NavLabel>Regulamin</NavLabel>
      </NavItem>
    </NavContainer>
  );
};

export default LeftNavigationBar;